import { render, staticRenderFns } from "./TutorialQrCode.vue?vue&type=template&id=485971de&scoped=true&"
import script from "./TutorialQrCode.vue?vue&type=script&lang=js&"
export * from "./TutorialQrCode.vue?vue&type=script&lang=js&"
import style0 from "./TutorialQrCode.vue?vue&type=style&index=0&id=485971de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485971de",
  null
  
)

export default component.exports